import React from 'react'
import {
  ChevronRight,
  TrendingUp,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
export default function SportsContent() {
  return (
    <div className="px-3 pt-3">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="flex items-center mb-4">
          <TrendingUp className="w-6 h-6 text-orange-500 mr-2" />
          <h1 className="text-white text-xl font-bold">Deportes</h1>
        </div>

        <div className="bg-gray-800 rounded-lg p-3 mb-4">
          <input
            type="text"
            placeholder="Buscar deportes..."
            className="w-full bg-gray-700 text-white rounded-lg py-2 px-3 text-sm focus:outline-none"
          />
        </div>

        {/* Deportes populares */}
        <div className="space-y-2 mb-6">
          {[
            { name: "Fútbol", icon: "⚽", count: 230 },
            { name: "Baloncesto", icon: "🏀", count: 85 },
            { name: "Tenis", icon: "🎾", count: 42 },
            { name: "Béisbol", icon: "⚾", count: 38 },
            { name: "Hockey", icon: "🏒", count: 24 },
            { name: "Golf", icon: "⛳", count: 12 },
          ].map((sport, index) => (
            <motion.div
              key={index}
              className="bg-gray-800 rounded-lg p-3 flex justify-between items-center"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <div className="flex items-center">
                <div className="mr-3 text-xl">{sport.icon}</div>
                <span className="text-white">{sport.name}</span>
              </div>
              <div className="flex items-center">
                <span className="text-gray-400 text-xs mr-2">
                  {sport.count} eventos
                </span>
                <ChevronRight className="w-4 h-4 text-gray-400" />
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
}
